import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat } from '../../../../../../../utils/creative-image-router-helper';
import { GmailAdEuMobileShellComponent } from './gmail-ad-eu-mobile-shell.component';

/** Gmail EU mobile ad previewing the square 1200x1200 / 600x600 upload. */
@Component({
    selector: 'app-gen-gmail-ad-eu-mobile-square',
    imports: [GmailAdEuMobileShellComponent],
    template: '<app-gen-gmail-ad-eu-mobile-shell [data]="data" [creativeFormat]="creativeFormat" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class GmailAdEuMobileSquarePreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  readonly creativeFormat: CreativeFormat = 'square';
}
